<template>
    <!-- <b-overlay :show="busy" rounded="sm"> -->

    <div>
        <b-card class="standardpage border-none">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="midata.icon" class="mr-1"></i>
                        <span>{{ midata.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <!-- {{ clients }} -->
            <b-nav class="pt-2 ml-2 mb-2 xs_pills" small pills>
                <b-nav-item class="nav-pills-hover-effect border-secondary strong" small @click="">*SLACS*
                    <span :id="'slac_total'" class="ml-1 badge badge-purple">{{ clients.length }}</span>
                </b-nav-item>
                <b-nav-item class="nav-pills-hover-effect border-secondary" small v-for="(client, index) in clients"
                    :key="client.slac" @click="slac = client.slac" :active="client.slac == slac">
                    <span :id="'slac_name_' + index" v-html="client.slac"></span>

                    <b-tooltip :target="'slac_name_' + index" placement="top">{{ client.slac }}</b-tooltip>

                </b-nav-item>
            </b-nav>
            <!-- <hr /> -->

            <b-card class="standardpage reports invoices border-none">
                <div class="availtable datatable text-left">
                    <b-card-body class="py-0">

                        <b-row>
                            <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Client SL A/C configured" label-size="sm">
                                    <treeselect placeholder="Select slac..." v-model="slac" :clearable="true"
                                        :options="slac_options">
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col> -->
                            <b-col cols="12" sm="6" md="4" xl="4">
                                <b-form-group label-cols="12" label="Client SL A/C configured" label-size="sm">
                                    <b-input-group class="treeselect_all" style="left:125px; top:-12px">
                                        <i class="fa fa-info-circle text-black" id="slacgroup"></i>
                                    </b-input-group>
                                    <b-tooltip target="slacgroup" triggers="hover" placement="top">To add or remove
                                        a SL A/C add the new SL A/C or delete it from the group</b-tooltip>

                                    <treeselect placeholder="New slac..." searchPromptText="Type at least 3 chars..."
                                        v-model="slacs" :multiple="true" :clearable="true" :async="true"
                                        :load-options="treeselect_loadSLAC" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested @input="slac_change">
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <!-- {{ midata.items }}  -->
                        <b-row>
                            <b-col cols="8">
                                <d-table classdivtable="availtable datatable footertotal_danger" refid="midata"
                                    :icon="midata.icon" :selectmode="'single'" :busy="midata.busy"
                                    :toolbarlibrary="midata.toolbarlibrary" :tools="midata.tools"
                                    :badges="midata.badges" :icons="midata.icons" :fields="midata.fields"
                                    :items="midata.items" :page="midata.page" :showpages="false" @load="midata_load"
                                    @click="midata_click" @select="midata_select">
                                </d-table>
                            </b-col>

                            <b-col v-if="midata.item.code">

                                <b-row class="mt-4">

                                    <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                                <b-form-group label="Code" label-for="code" label-cols="12">
                                                    <b-input-group class="treeselect_all" style="left:33px; top:-12px">
                                                        <i class="fa fa-info-circle text-black" id="code"></i>
                                                    </b-input-group>
                                                    <b-tooltip target="code" triggers="hover" placement="top">Code
                                                        tooltip</b-tooltip>
                                                    <b-input-group>
                                                        <b-form-input type="text" v-model="item.code"
                                                            placeholder="Enter code" size="sm"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary"
                                                                @click="item.code = ''">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                            </b-col> -->
                                    <b-col cols="12" sm="6">
                                        <b-form-group label="Label" label-for="label" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="midata.item.label"
                                                    placeholder="Enter label" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="midata.item.label = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6">
                                        <b-form-group label="Sort" label-for="sort" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="midata.item.sort"
                                                    placeholder="Enter sort" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="midata.item.sort = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6">
                                        <b-form-group label="Type" label-for="type" label-cols="12">
                                            <treeselect instanceId="type" type="number" v-model="midata.item.type"
                                                :clearable="false" :options="options_type"></treeselect>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12"> <b-row align-v="end"
                                            class="nopadding my-2 mt-0 background-transparent" no-gutters>
                                            <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                                                Required is set by GEN events or Supplier Type, or just Required always.
                                            </b-col>
                                        </b-row>

                                        <b-row>
                                            <b-col>
                                                <b-form-group label="GEN events?" label-for="eventcode_isgen"
                                                    label-cols="12">
                                                    <b-form-radio-group id="eventcode_isgen"
                                                        v-model="midata.item.eventcode_isgen" :options="[
                                                            { text: 'No', value: '0' },
                                                            { text: 'Yes', value: '1' },
                                                        ]" buttons button-variant="outline-success" size="sm"
                                                        name="radio-btn-outline"></b-form-radio-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col cols="12" sm="6">
                                                <b-form-group label="Supplier Type" label-for="stype" label-cols="12">
                                                    <treeselect instanceId="stype" type="number"
                                                        placeholder="All or select..." v-model="midata.item.stype"
                                                        :clearable="true" :multiple="true"
                                                        :options="suppliertype_options">
                                                    </treeselect>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group label="Required?" label-for="required" label-cols="12">
                                                    <b-form-radio-group id="required" v-model="midata.item.required"
                                                        :disabled="midata.item.active == 0 || midata.item.stype || midata.item.eventcode_isgen == 1"
                                                        :options="[
                                                            { text: 'No', value: '0' },
                                                            { text: 'Yes', value: '1' },
                                                        ]" buttons button-variant="outline-success" size="sm"
                                                        name="radio-btn-outline"></b-form-radio-group>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-row align-v="end" class="nopadding my-2 mt-0 background-transparent"
                                            no-gutters>
                                            <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                                                Displayed on invoice, scripted or active.
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <b-form-group label="OnInvoice?" label-for="oninvoice" label-cols="12">
                                                    <b-form-radio-group id="oninvoice" v-model="midata.item.oninvoice"
                                                        :options="[
                                                            { text: 'No', value: '0' },
                                                            { text: 'Yes', value: '1' },

                                                        ]" buttons button-variant="outline-success" size="sm"
                                                        name="radio-btn-outline"></b-form-radio-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group label="Script?" label-for="script" label-cols="12">
                                                    <b-form-radio-group id="script" v-model="midata.item.script"
                                                        :options="[
                                                            { text: 'No', value: '0' },
                                                            { text: 'Yes', value: '1' },

                                                        ]" buttons button-variant="outline-success" size="sm"
                                                        name="radio-btn-outline"></b-form-radio-group>
                                                </b-form-group>
                                            </b-col>
                                            <b-col>
                                                <b-form-group label="Active?" label-for="active" label-cols="12">
                                                    <b-form-radio-group id="active" v-model="midata.item.active"
                                                        :options="[
                                                            { text: 'No', value: '0' },
                                                            { text: 'Yes', value: '1' },

                                                        ]" buttons button-variant="outline-success" size="sm"
                                                        name="radio-btn-outline"></b-form-radio-group>
                                                </b-form-group>
                                            </b-col>

                                        </b-row>

                                    </b-col>

                                    <b-col cols="12">
                                        <b-form-group label="Default Value" label-for="value" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="midata.item.value"
                                                    placeholder="Enter default value" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="midata.item.value = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="midata.item.type == 'listofvalues'">
                                    <b-col cols="12">
                                        <b-form-group label="List Of Values" label-for="options" label-cols="12">
                                            <b-row>
                                                <b-col>
                                                    <b-input-group class="treeselect_all " style="left:79px; top:-13px">
                                                        <i id="liofv" class="fa fa-info-circle text-black ml-1"></i>
                                                    </b-input-group>
                                                    <b-tooltip target="liofv" triggers="hover" placement="top">If
                                                        you change the list of
                                                        values please use Validate Input.
                                                    </b-tooltip>
                                                </b-col>
                                                <b-col class="mr-4">
                                                    <b-input-group class="treeselect_all justify-content-end ">
                                                        <span style="padding-top: 0.3em" class="text-primary"
                                                            id="input-tooltip">Validate
                                                            Input</span>
                                                        <b-form-checkbox id="options_input" v-model="options_input"
                                                            class="z-0">
                                                        </b-form-checkbox>
                                                    </b-input-group>
                                                </b-col>
                                            </b-row>

                                            <b-form-textarea v-if="options_input" v-model="midata.item.options"
                                                placeholder="List Of Values" rows="5" class="smalltextarea">
                                            </b-form-textarea>
                                            <!-- <b-input-group v-else class="z-0">
                                                        <b-form-tags input-id="midata.item.options" v-model="tags"
                                                            tag-variant="primary" separator=",;" no-add-on-enter
                                                            placeholder="Paste List Of Values" size="sm" class="h-29"
                                                            add-button-text="+" add-on-change remove-on-delete
                                                            add-button-variant="outline-primary"
                                                            @input="tagsInput"></b-form-tags>
                                                        <b-input-group-append>
                                                            <b-button size="sm" variant="outline-secondary"
                                                                @click="tags = []">
                                                                <i class="fa fa-remove"></i>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group> -->
                                            <b-form-textarea v-else v-model="midata.paste" placeholder="Options Paste"
                                                rows="5" class="smalltextarea"></b-form-textarea>
                                        </b-form-group>

                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label="Notes" label-for="notes" label-cols="12">
                                            <b-input-group class="treeselect_all" style="left:36px; top:-13px">
                                                <i id="notes-tooltip" class="fa fa-info-circle text-black"></i>
                                            </b-input-group>
                                            <b-tooltip target="notes-tooltip" triggers="hover" placement="top">For
                                                BN/ Booker Name enter BN/
                                                in notes below to use the booker name initials
                                                tables.
                                            </b-tooltip>
                                            <b-form-textarea id="notes" v-model="midata.item.notes" placeholder="Notes"
                                                rows="5" class="smalltextarea"></b-form-textarea>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <!-- </p>
                                    </b-tab>
                                </b-tabs> -->
                    </b-card-body>
                    <b-card-footer class="nopadding border-none mx-2">
                        <b-row no-gutters>
                            <b-col cols="auto" class="text-left mr-3">
                                <b-button squared size="sm" variant="primary" @click="midata_save"
                                    :disabled="midata.items.length == 0 ? true : false"
                                    v-if="user.permissions.includes('setup_mifields.admin')">
                                    <i class="fa fa-check"></i>
                                    Save It
                                </b-button>
                            </b-col>
                            <b-col class="text-left my-auto">
                                <div v-if="midata.busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>
                            <!-- <b-col class="text-right" cols="8">
                                        <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                                            <i class="fa fa-chevron-left pr-1"></i>
                                            Back
                                        </b-button>
                                    </b-col> -->
                        </b-row>



                        <b-row class="pt-3">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Client SL A/C to setup" label-size="sm">
                                    <treeselect placeholder="New slac..." searchPromptText="Type at least 3 chars..."
                                        v-model="newslac" :multiple="true" :clearable="true" :async="true"
                                        :load-options="treeselect_loadSLAC" :show-count="true"
                                        :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                                        search-nested>
                                        <div slot="value-label" slot-scope="{ node }">
                                            {{ node.raw.id }}
                                        </div>
                                    </treeselect>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3" class="mt-3">
                                <b-button :disabled="newslac.length == 0 ? true : false" class="" squared size="sm"
                                    variant="primary" @click="midata_setup">
                                    <i class="fa fa-play"></i>
                                    Setup
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row class="pt-3">
                            <b-col cols="8">
                                <b-alert :show="message2 ? true : false" variant="danger">
                                    <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                            <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                        <b-col>
                                            <span v-html="message2"></span></b-col></b-row>
                                </b-alert></b-col>
                        </b-row>

                    </b-card-footer>

                    <div v-show="component">
                        <component :is="component" :selection="mifields.selected" :config="cconfig"
                            @discard="mifields_click('discard')" @go="mifields_click('go')"></component>
                    </div>

                    <b-card-footer class="mt-2 ml-1">
                        <div class="text-center">
                            <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                                <i class="fa fa-cogs mr-2"></i>Setup All
                            </b-button>
                        </div>
                    </b-card-footer>
                </div>
            </b-card>

        </b-card>
    </div>
    <!-- </b-overlay> -->
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import MIFieldAPI from "./Components/Setup_MIFieldAPI";

function tabToObjArr(text) {

    let raw = text.trim().split('"').join("")
    let allcols = raw.split("\t")

    let headers = raw.split("\n")[0].split("\t")
    let cb = headers.length - 1
    let cols = []
    for (let i = 0; i < allcols.length; i++) {
        if (i == cb) {
            let parts = allcols[i].trim().split("\n")
            for (let k = 0; k < parts.length; k++) {
                cols.push(parts[k].trim())
            }
            cb += headers.length - 1
        } else {
            cols.push(allcols[i].trim().split("\n").join(",").replace(/\s+/g, ' '))
        }
    }
    console.log('cols=', cols)

    cb = headers.length - 1
    let rows = []
    let item = {}
    let k = 0
    for (let i = 0; i < cols.length; i++) {
        if (i == cb) {
            item[headers[k]] = cols[i]
            rows.push(item)
            cb += headers.length
            item = {}
            k = 0
        } else {
            item[headers[k]] = cols[i]
            k += 1
        }
    }
    return rows;
}

export default {
    name: "MIFieldEdit",
    components: { MIFieldAPI },
    async mounted() {

        this.accessdenied();
        await this.midata_load();

        this.clients = []
        try {
            const response = await this.$apollo.query({
                query: gql`
                        query setup_mifields_slacs {
                            setup_mifields_slacs {
                                slac:id
                            }
                        }
                    `,
            });
            this.clients = response.data.setup_mifields_slacs
        } catch (error) {
            console.log(error);
        }

        await this.midata_ddl()
    },
    data() {
        return {
            message: null,
            message2: null,
            clients: [],
            slac_total: 0,
            slac: null,
            slac_options: [],
            newslac: [],
            slacs: [],
            tags: [],
            stype: [],
            options_type: [
                { id: 'input', label: 'Text Input' },
                { id: 'listofvalues', label: 'List Of Values' }
            ],
            options_input: false,
            suppliertype_options: [],
            midata: {
                icon: "fa fa-terminal text-primary",
                title: "MI Fields",
                debounce: 500,
                busy: false,

                selectall: false,
                pastespecial: false,
                paste: null,
                paste_selected: ["firstrowheader", "reversenamecap"],
                paste_options: [
                    { id: "firstrowheader", label: "First Row Headers", disabled: true },
                    { id: "secondrowskip", label: "Second Row Skip" },
                    { id: "filldown", label: "Fill Down" },
                ],
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-trash text-danger",
                        position: "toolbar",
                        action: "purge",
                        label: "Delete MI",
                        disabled: true,
                        component: {
                            name: null,
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-code text-purple",
                        position: "toolbar",
                        action: "mifieldapi",
                        label: "API",
                        disabled: true,
                        component: {
                            name: "MIFieldAPI",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-long-arrow-up text-info",
                        position: "actions",
                        action: "moveup",
                        label: "Sort Up",
                        component: {
                            name: "",
                        },
                    },
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-long-arrow-down text-info",
                        position: "actions",
                        action: "movedown",
                        label: "Sort Down",
                        component: {
                            name: "",
                        },
                    }
                ],
                tools: "go,clipboard,purge,mifieldapi,moveup,movedown",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px text-primary",
                    },
                    // {
                    //     key: "id",
                    //     label: "ID",
                    //     sortable: true,
                    //     class: "d-none d-sm-table-cell",
                    // },
                    {
                        key: "code",
                        label: "Code",
                        sortable: true,
                        class: "text-right d-none d-sm-table-cell",

                    },
                    {
                        key: "label",
                        label: "Label",
                        sortable: true,
                        class: "d-none d-sm-table-cell",

                    },
                    {
                        key: "sort",
                        label: "Sort",
                        sortable: true,
                        class: "d-none d-sm-table-cell",

                    },
                    {
                        key: "script",
                        label: "Script?",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "active",
                        label: "Active?",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "required",
                        label: "Required?",
                        sortable: true,
                        class: "d-none d-sm-table-cell",

                    },
                    {
                        key: "oninvoice",
                        label: "OnInvoice?",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },

                    {
                        key: "value",
                        label: "Default Value",
                        sortable: true,
                        class: "d-none d-sm-table-cell",

                    },
                    //{
                    //   key: "updated_by",
                    //   label: "Updated By",
                    //   sortable: true,
                    //   class: "text-center",
                    //},
                    // {
                    //     key: "updated_at",
                    //    label: "Updated At",
                    //    sortable: true,
                    //    class: "text-right",
                    // formatter: (value, key, item) => {
                    //   let result = "Never";
                    //   if (value) {
                    //     result = this.$moment
                    //       .unix(value / 1000)
                    //       .format("DD/MM/YYYY hh:mm");
                    //   }
                    //   return result;
                    // },
                    //   },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-110px",
                    },

                ],
                badges: [
                    {
                        key: "required",
                        type: "badge",
                        Yes: "success",
                        No: "danger",
                        formatter: (value, key, item) => {
                            if (value == 0) {
                                return "No";
                            } else if (value == 1) {
                                return "Yes";
                            } else {
                                return "";
                            }
                        },
                    },
                    {
                        key: "script",
                        type: "badge",
                        Yes: "success",
                        No: "danger",
                        formatter: (value, key, item) => {
                            if (value == 0) {
                                return "No";
                            } else if (value == 1) {
                                return "Yes";
                            } else {
                                return "";
                            }
                        },
                    },
                    {
                        key: "active",
                        type: "badge",
                        Yes: "success",
                        No: "danger",
                        formatter: (value, key, item) => {
                            if (value == 0) {
                                return "No";
                            } else if (value == 1) {
                                return "Yes";
                            } else {
                                return "";
                            }
                        },
                    },
                    {
                        key: "oninvoice",
                        type: "badge",
                        Yes: "success",
                        No: "danger",
                        formatter: (value, key, item) => {
                            if (value == 0) {
                                return "No";
                            } else if (value == 1) {
                                return "Yes";
                            } else {
                                return "";
                            }
                        },
                    },
                ],
                icons: [
                    {
                        key: "type",
                        'input': "fa fa-terminal text-primary w-15px text-center",
                        'listofvalues': "fa fa fa-bars text-primary w-15px text-center",
                    }
                ],
                item: {},
                items: [],
                selected: [],
                denied: [],
            },
            item: { value: null, code: null, label: null, slac: [], notes: null, required: '0', script: '0', active: '0', oninvoice: '0', sort: '0' },
            options: {
                title: "MIFieldEdit",
                icon: "fa fa-list",
            },
        };
    },
    watch: {
        async newslac() {
            this.message2 = null
            if (this.newslac.length > 0) {
                this.midata.items = [];
                this.slac = null
            }
        },
        async slac() {
            if (this.slac) {
                await this.midata_load()
                this.slacs = this.slac.split(",")
            } else {
                this.midata.items = [];
            }
        },
        async tags() {
            let values = []
            for (var i = 0; i < this.tags.length; i++) {
                values.push({ id: this.tags[i], label: this.tags[i] })
            }
            this.midata.item.options = JSON.stringify(values);
        },
        async options_input() {
            if (!this.midata.item.options) {
                let list = this.options_paste_read()
                this.midata.item.options = JSON.stringify(list);
                this.midata.paste = list.map(o => o.label).join("\n")

                // let list = this.paste.trim().split("\n")
                // let values = []
                // for (var i = 0; i < list.length; i++) {
                //     values.push({ id: list[i], label: list[i] })
                // }
                // // console.log("values", values);
                // this.midata.item.options = JSON.stringify(values);
            } else {
                let list = this.midata.paste.trim().split("\n")
                let labels = []
                if (this.midata.item.options) {
                    labels = JSON.parse(this.midata.item.options).map(o => o.label);
                }
                if (list.length != labels.length) {
                    let list = this.midata.paste.trim().split("\n")
                    let values = []
                    for (var i = 0; i < list.length; i++) {
                        values.push({ id: list[i], label: list[i] })
                    }
                    console.log("values", values);
                    this.midata.item.options = JSON.stringify(values);
                }
            }
            // let list = JSON.parse(this.midata.item.options).map(o => o.label);
            //this.midata.item.options.map(o => o.label);
            // this.tags = list;
        },
        "midata.item.script": {
            immediate: true,
            async handler(newVal, oldVal) {
                for (var i = 0; i < this.midata.items.length; i++) {
                    this.midata.items[i].script = newVal
                }
            }
        },


    },
    methods: {
        accessdenied() {
            this.midata.denied = [];
            if (!this.user.permissions.includes("setup_mifields.admin")) {
                this.midata.denied.push("purge");
            }

        },
        async midata_ddl() {
            this.slac_options = []
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query setup_mifields_slacs {
                            setup_mifields_slacs {
                                id
                                label
                            }
                        }
                    `,
                });
                this.slac_options = response.data.setup_mifields_slacs
            } catch (error) {
                console.log(error);
            }

            this.suppliertype_options = []
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query suppliertypes {
                        suppliertypes {
                            id
                            label
                            faicon
                        }
                        }
                    `,
                });
                this.suppliertype_options = response.data.suppliertypes.filter(o => o.faicon != '');
            } catch (error) {
                console.log(error);
            }
        },
        async midata_load() {

            if (!this.slac) { return }

            let state = this.midata;

            let variables = {
                slac: this.slac ? this.slac : null,
            };
            console.log("variables", variables);

            state.busy = true;
            state.items = []

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query setup_mifields($slac: String) {
                            setup_mifields(slac: $slac) {
                                id
                                code
                                label
                                value
                                sort
                                required
                                active
                                script
                                oninvoice
                                eventcode_isgen
                                type
                                stype
                                options
                                notes
                                slac
                                updated_by
                                updated_at
                            }
                        }
                    `,
                    variables,
                });
                if (response.data.setup_mifields.length > 0) {
                    this.midata.items = response.data.setup_mifields
                    this.slac = this.midata.items[0].slac//.split(",")

                }
            } catch (error) {
                console.log(error);
            }
            state.busy = false;
        },
        async midata_setup() {

            let state = this.midata;

            for (var i = 0; i < this.newslac.length; i++) {

                for (var k = 0; k < this.slac_options.length; k++) {
                    if (this.slac_options[k].id.includes(this.newslac[i])) {
                        console.log("slac found", this.slac_options[k].id, this.newslac[i])
                        this.message2 = "<span>This client already has MI Fields setup.</span>";
                        return
                    }
                }
            }


            if (await this.$bvModal.msgBoxConfirm('Would you like to setup MI Fields for this client?', {
                title: 'This client does not have MI Fields setup.',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {

                state.busy = true;

                let variables = {
                    name: "midata",
                };
                console.log("variables", variables);

                try {
                    const response = await this.$apollo.query({
                        query: gql`
                        query setup_systemsettings($name: String) {
                        setup_systemsettings(name: $name) {
                            data
                        }
                        }
                    `,
                        variables,
                    });
                    if (response.data.setup_systemsettings.length > 0) {
                        let mifields = JSON.parse(response.data.setup_systemsettings[0].data);
                        mifields = mifields.map(o => ({ ...o, slac: this.newslac.length > 0 ? this.newslac.join(",") : null }))
                        mifields = mifields.map(o => ({ ...o, updated_by: this.user.initials }))
                        mifields = mifields.map(o => ({ ...o, updated_at: this.$moment().format("YYYY-MM-DD HH:mm") }))
                        this.midata.items = mifields;
                    }
                    this.message2 = "<span>This set of MI Fields has not been saved yet.</span>";
                } catch (error) {
                    console.log(error);
                }

            }

            state.busy = false;
        },
        async midata_save() {

            let state = this.midata;

            let variables = {
                rows: this.midata.items
            }
            // variables.rows = variables.rows.map(o => ({ ...o, slac: this.slac.length > 0 ? this.slac.join(",") : null }))
            for (var i = 0; i < variables.rows.length; i++) {
                if (Array.isArray(variables.rows[i].stype)) {
                    variables.rows[i].stype = variables.rows[i].stype.join(",")
                }

            }
            console.log("variables", variables);
            state.busy = true;

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation setup_mifields_save($rows: [setup_mifields_input]) {
                            setup_mifields_save(rows: $rows) {
                                id
                            }
                        }
                    `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";

            }
            state.busy = false;

            await this.midata_ddl()

            if (!this.slac && this.newslac.length > 0) {
                this.slac = this.newslac[0]
                this.newslac = []
            } else {
                this.newslac = []
            }
            this.message2 = null

        },
        async midata_click(a, ss) {

            let state = this.midata;

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []

                    break;

                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;

                    break;
                case "go":
                    this.component = null;
                    await this.midata_ddl()
                    await this.midata_load()
                    break;

                case "save":
                    await this.midata_save()
                    break;

                case "purge":
                    await this.midata_purge();
                    break;

                case "moveup":
                    this.moveup(ss);
                    break;

                case "movedown":
                    this.movedown(ss);
                    break;

                case "mifieldapi":
                    if (this.component) {
                        this.component = null
                    } else {
                        this.component = "MIFieldAPI";
                    }
                    break;
            }
        },
        async midata_select(ss, tools) {
            let state = this.midata;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "add", "download", "clipboard", "purge", "mifieldapi"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["moveup", "movedown"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
            if (state.selected.length > 0) {
                state.item = state.selected[0]  // WHAT YOU SELECTED

                if (state.item.stype) {
                    if (!Array.isArray(state.item.stype)) {
                        state.item.stype = state.item.stype.split(",")
                    }
                }

                if (state.item.type == 'listofvalues') {
                    if (state.item.options) {
                        let list = JSON.parse(state.item.options).map(o => o.label);
                        this.midata.paste = list.join("\n");
                    } else {
                        this.midata.paste = null;
                    }
                } else {
                    this.midata.paste = null;
                }

            } else {
                state.item = {}
            }
        },
        async midata_purge(ss) {

            if (!this.slac) { return }

            let state = this.midata

            if (await this.$bvModal.msgBoxConfirm('All MI fields for this SL/AC will be removed', {
                title: 'Please confirm you want to unconfigure ' + this.slac + '?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {

                state.busy = true

                let rows = [];
                state.items.forEach(function (v) {
                    rows.push({ id: v.id });
                });

                let variables = {
                    rows,
                };

                try {
                    const response = await this.$apollo.mutate({
                        mutation: gql`
                        mutation setup_mifields_delete(
                        $rows: [setup_mifields_input]
                        ) {
                        setup_mifields_delete(rows: $rows) {
                            id
                        }
                        }
                    `,
                        variables,
                    });
                } catch (error) {
                    console.log(error);
                }

                this.newslac = []
                this.slac = null

                await this.midata_ddl()

            }
            state.busy = false

        },

        async slac_change() {
            console.log("slac_change", this.slacs);

            if (this.slac == this.slacs.join(",")) { return }

            let state = this.midata;

            let variables = {
                rows: []
            }

            console.log("variables", this.midata.items);
            for (var i = 0; i < this.midata.items.length; i++) {
                let mifield = this.midata.items[i]
                variables.rows.push({ id: mifield.id, slac: this.slacs.join(",") })
            }

            console.log("variables", variables);
            state.busy = true;

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation setup_mifields_save($rows: [setup_mifields_input]) {
                            setup_mifields_save(rows: $rows) {
                                id
                            }
                        }
                    `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";

            }
            state.busy = false;

            await this.midata_load()
            await this.midata_ddl()

            this.clients = []
            try {
                const response = await this.$apollo.query({
                    query: gql`
                            query setup_mifields_slacs {
                                setup_mifields_slacs {
                                    slac:id
                                }
                            }
                        `,
                });
                this.clients = response.data.setup_mifields_slacs
            } catch (error) {
                console.log(error);
            }


        },

        async moveup() {

        },
        async movedown() {

        },
        tagsInput(tag) {
            console.log("tagsInput", tag);
            return tag
        },
        addTag(newTag) {
            console.log("newTag", newTag);
        },

        options_paste_read() {
            console.log('options_paste_read')

            let state = this.midata

            if (state.paste) {

                let rows = tabToObjArr(state.paste)

                let rowstart = 1
                if (state.paste_selected.includes("secondrowskip")) {
                    rowstart += 1
                }

                // MAKE OBJECT ITEMS
                let items = []
                for (let i = rowstart; i < rows.length; i++) {
                    items.push(rows[i])
                }

                if (state.paste_selected.includes("filldown")) {
                    let lastitem = {}
                    for (let i = 0; i < items.length; i++) {
                        let item = items[i]
                        for (let prop in lastitem) {
                            if (!item[prop]) {
                                if (lastitem[prop]) {
                                    item[prop] = lastitem[prop]
                                }
                            }
                        }
                        lastitem = item
                    }
                }

                let newrows = []
                for (let i = 1; i < rows.length; i++) {
                    let obj = rows[i]
                    let value = {}
                    let k = 0
                    for (let prop in obj) {
                        console.log('prop', prop, k)
                        if (k == 0) {
                            value.id = obj[prop]
                            k += 1
                        } else if (k == 1) {
                            value.label = obj[prop]
                            k += 1
                        }
                    }
                    newrows.push(value)
                }

                rows = newrows

                return rows


            }

        },

    },
};
</script>

<style></style>